/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Layout, Menu, Row, Col, Icon
} from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CustomScrollbars from 'util/CustomScrollbars';
import UserInfo from 'components/UserInfo';
import Auxiliary from 'util/Auxiliary';
import { AuthenticationMenu } from 'src/helpers/Authorization';
import Permission from 'src/helpers/Permission';
import { setCookieValue, getCookieValue } from 'src/util/Common';
import {
  NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE
} from '../../constants/ThemeSetting';
import { switchLanguage, toggleCollapsedSideNav } from '../../appRedux/actions/Setting';
import languageData from './languageData';

const { Header } = Layout;

class Topbar extends Component {
  languageMenu = () => (
    <CustomScrollbars className="gx-popover-lang-scroll">
      <ul className="gx-sub-popover">
        {languageData.map(language => (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          <li
            key={JSON.stringify(language)}
            className="gx-media gx-pointer"
            onClick={e => this.props.switchLanguage(language)
            }
          >
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className="gx-language-text">{language.name}</span>
          </li>
        ))}
      </ul>
    </CustomScrollbars>
  );

  onClickMenu = (data) => {
    this.props.toggleCollapsedSideNav(true);
    const { key } = data;
    let type = '';
    switch (key) {
      case '/quan-ly-thuong-mai':
        type = Permission.P_QLTM;
        break;
      case '/quan-ly-cong-nghiep':
        type = Permission.P_QLCN;
        break;
      case '/ky-thuat-an-toan-moi-truong':
        type = Permission.P_KTATMT;
        break;
      case '/quan-ly-nang-luong':
        type = Permission.P_QLNL;
        break;
      case '/thi-truong':
        type = Permission.P_QLTT;
        break;
      case '/dau-tu-xuat-nhap-khau':
        type = Permission.P_QLDT;
        break;
      default:
        break;
    }
    setCookieValue('currentMenuTop', { key, type });
  }

  render() {
    const {
      width, navCollapsed, navStyle, userInfo, activedVaiTro
    } = this.props;
    const key = getCookieValue('currentMenuTop') ? getCookieValue('currentMenuTop').key : '';
    /** All */
    const thongKeAll = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_ALL, Permission.XEM]);

    /** Quản lý thương mại */
    const phongQLTM = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLTM, Permission.XEM]);
    // Thương nhân
    const dmThuongNhan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN, Permission.XEM]);
    const isThuongNhan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.THUONG_NHAN, Permission.XEM]);
    // Xăng dầu
    const qlXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_XANG_DAU, Permission.XEM]);
    const dmCoQuanChuQuan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_QUAN_CHU_QUAN, Permission.XEM]);
    const dmDaiLyXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DAI_LY_XD, Permission.XEM]);
    const bcCuaHangXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CUA_HANG_XANG_DAU, Permission.XEM]);
    // Thuốc lá
    const qlThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUOC_LA, Permission.XEM]);
    const dmNhaBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_NHA_BAN_BUON, Permission.XEM]);

    const bcBanBuonThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_BUON_THUOC_LA, Permission.XEM]);
    const tkTinhHinhKinhDoanhThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THUOC_LA, Permission.XEM]);
    // Vệ sinh ATTP
    const qlVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_VSATTP, Permission.XEM]);
    const dmNganhNgheKD = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_NGANH_NGHE_KD, Permission.XEM]);
    const dmDanhSachCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_SO_VSATTP, Permission.XEM]);
    const bcVSATTTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_ATTP, Permission.XEM]);
    const tkTongHopCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TONG_HOP_CSVS_ATTP, Permission.XEM]);
    const tkCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CSVSATTP, Permission.XEM]);
    // Rượu
    const qlRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_RUOU, Permission.XEM]);
    const dmChungLoaiRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CHUNG_LOAI_RUOU, Permission.XEM]);
    const bcRuouTC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_TC, Permission.XEM]);
    const bcRuouCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_CONG_NGHIEP, Permission.XEM]);
    // Chợ
    const qlCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CHO, Permission.XEM]);
    const bcCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CHO, Permission.XEM]);
    const tkPhatTrienCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_PHAT_TRIEN_CHO, Permission.XEM]);
    // Gas
    const qlGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_GAS, Permission.XEM]);
    const bcGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_GAS, Permission.XEM]);
    const tkCuaHangGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CUA_HANG_GAS, Permission.XEM]);
    // Doanh nghiep đa cấp
    const qlDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DNBH_DA_CAP, Permission.XEM]);
    const bcDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DOANH_NGHIEP_DA_CAP, Permission.XEM]);
    const tkDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DOANH_NGHIEP_DA_CAP, Permission.XEM]);
    // Hội chợ
    const qlHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOI_CHO, Permission.XEM]);
    const bcHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_HOI_CHO, Permission.XEM]);
    const tkHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_HOI_CHO, Permission.XEM]);
    // Hợp đông theo mẫu
    const qlHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOP_DONG_THEO_MAU, Permission.XEM]);
    const bcHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_HOP_DONG_THEO_MAU, Permission.XEM]);
    const tkHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DOANH_NGHIEP_DANG_KY_HOP_DONG_THUONG_MAI, Permission.XEM]);
    // Quản lý đăng ký dấu
    const qlDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DANG_KY_DAU, Permission.XEM]);
    const bcDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DANG_KY_DAU, Permission.XEM]);
    const tkDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DANG_KY_DAU, Permission.XEM]);

    // Thuốc lá 2020
    const qlThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUOC_LA_2020, Permission.XEM]);
    const dmThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THUOC_LA_2020, Permission.XEM]);
    const dmQuanLyThuongNhanThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN_THUOC_LA, Permission.XEM]);
    const bcThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUOC_LA_2020, Permission.XEM]);
    const bcThuongNhanBanLe = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_BAN_LE, Permission.XEM]);
    const bcThuongNhanDuocCapPhep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_DUOC_CAP_PHEP, Permission.XEM]);
    const bcTinhHinhKinhDoanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_KINH_DOANH, Permission.XEM]);
    const bcTrongCayThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TRONG_CAY_THUOC_LA, Permission.XEM]);
    const bcDauTuTrongCayThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DAU_TU_TRONG_CAY_THUOC_LA, Permission.XEM]);
    const bcThuongNhanBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_BAN_BUON, Permission.XEM]);
    const bcPhanPhoiSanPhamThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_PHAN_PHOI_SAN_PHAM_THUOC_LA, Permission.XEM]);
    const bcBanHangTaiCacTinhThanhPho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_HANG_TAI_CAC_TINH_THANH_PHO, Permission.XEM]);
    const bcBanHangTaiCacDiemBanLe = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_HANG_TAI_CAC_DIEM_BAN_LE, Permission.XEM]);

    // Rượu 2020
    const qlRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_RUOU_2020, Permission.XEM]);
    const dmRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_RUOU_2020, Permission.XEM]);
    const dmQuanLyThuongNhanRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN_RUOU, Permission.XEM]);
    const bcRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_2020, Permission.XEM]);
    const bcTinhHinhSanXuatRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_SAN_XUAT_RUOU, Permission.XEM]);
    const bcTinhHinhSanXuat = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_SAN_XUAT, Permission.XEM]);
    const bcTinhHinhTieuThu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_TIEU_THU, Permission.XEM]);
    const bcPhanPhoiRuouBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_PHAN_PHOI_RUOU_BAN_BUON, Permission.XEM]);
    const bcTinhHinhMuaVao = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_MUA_VAO, Permission.XEM]);
    const bcTinhHinhBanRa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_BAN_RA, Permission.XEM]);
    // const bcBanLeRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_LE_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    // const bcRuouThuCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_THU_CONG, Permission.XEM]);
    const bcSanXuatRuouBanChoDoanhNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_BAN_CHO_DOANH_NGHIEP, Permission.XEM]);
    const bcSanXuatRuouKinhDoanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_KINH_DOANH, Permission.XEM]);
    const bcBanLeRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_LE_RUOU, Permission.XEM]);
    // const bcRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    const bcBanRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    const bcSanXuatRuouCongNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_CONG_NGHIEP, Permission.XEM]);
    const bcTinhHinhKinhDoanhRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_KINH_DOANH_RUOU, Permission.XEM]);
    const bcRuouCoDoConDuoi55 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_CO_DO_CON_DUOI_5_5, Permission.XEM]);
    // Quản lý Biểu mẫu khác
    const qlBieuMauKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_BIEU_MAU_KHAC, Permission.XEM]);
    const bcTongMucBanLeHangHoa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TONG_MUC_BAN_LE_HANG_HOA, Permission.XEM]);
    const bcTieuChiCshttmNongThon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TIEU_CHI_CSHTTM_NONG_THON, Permission.XEM]);

    // Phòng quản lý công nghiệp
    const phongQLCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLCN, Permission.XEM]);
    // Quản lý cụm CN - Dự án
    const qlCumCNDA = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CUM_CN_DA, Permission.XEM]);
    const dmCumCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CUM_CONG_NGHIEP, Permission.XEM]);
    const dmCoSoHaTang = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CO_SO_HA_TANG_THDT, Permission.XEM]);
    const dmDuAn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN, Permission.XEM]);
    const bcCCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CUM_CONG_NGHIEP, Permission.XEM]);
    const bcDuAn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DU_AN, Permission.XEM]);
    const tkKetCauHaTang = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THDT_KCHT, Permission.XEM]);
    // Quản lý thương mại điện tử
    const qlTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_TMDT, Permission.XEM]);
    const bcTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_MAI_DIEN_TU, Permission.XEM]);
    const tkTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TMDT, Permission.XEM]);
    // Quản lý khuyến công
    const qlKhuyenCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_KHUYEN_CONG, Permission.XEM]);
    const bcKhuyenCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KHUYEN_CONG, Permission.XEM]);
    const bcKhuyenCongDP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KHUYEN_CONG_DIA_PHUONG, Permission.XEM]);
    const bcKhuyenCongUT = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KHUYEN_CONG_UOC_TINH, Permission.XEM]);
    const bcKqHoTro = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KET_QUA_HO_TRO, Permission.XEM]);
    const bcUocTinhThucHien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_UOC_TINH_THUC_HIEN, Permission.XEM]);
    // Quản lý khu CN
    const qlKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_KHU_CN, Permission.XEM]);
    const dmQLKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KHU_CONG_NGHIEP, Permission.XEM]);
    const dmKcn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KCN, Permission.XEM]);
    const dmDuAnDauTu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN_DAU_TU, Permission.XEM]);
    const bcKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KHU_CONG_NGHIEP, Permission.XEM]);
    const tkKhuCongNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_KHU_CONG_NGHIEP, Permission.XEM]);
    // Sản phẩm công nghiệp
    const qlSanPhamCn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_SAN_PHAM_CN, Permission.XEM]);
    const bcMotSoSpcnChuYeu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_MOT_SO_SPCN_CHU_YEU, Permission.XEM]);
    const bcChiSoSanXuatCn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CHI_SO_SAN_XUAT_CN, Permission.XEM]);
    const bcKqBinhChonSpcnTieuBieu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KQ_BINH_CHON_SPCN_TIEU_BIEU, Permission.XEM]);

    /** Kỹ thuật ATMT */
    const phongKTATMT = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_KTATMT, Permission.XEM]);
    // Vật liệu nổ
    const qlVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_VLN, Permission.XEM]);
    const dmDoanhNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_DOANH_NGHIEP, Permission.XEM]);
    const dmLoaiHinhHD = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_LOAI_HINH_HD, Permission.XEM]);
    const bcVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_VLN, Permission.XEM]);
    const tkCapPhepVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_GIAY_PHEP_VLNCN, Permission.XEM]);
    // Hóa chất
    const qlHoaChat = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOA_CHAT, Permission.XEM]);
    const bcCoSoHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_SO_SU_DUNG_HOA_CHAT, Permission.XEM]);
    const bcLoaiHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.LOAI_HOA_CHAT, Permission.XEM]);
    const bcSuCoHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TINH_HINH_SU_CO_HOA_CHAT, Permission.XEM]);
    const bcThanhTraHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THANH_TRA_HC, Permission.XEM]);
    const tkLoaiHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_LOAI_HOA_CHAT, Permission.XEM]);
    const tkSuCoHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TINH_HINH_SU_CO_HOA_CHAT, Permission.XEM]);
    const tkThanhTraHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THANH_TRA_HC, Permission.XEM]);

    // công bố hợp quy
    const qlCongBoHopQuy = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CONG_BO_HOP_QUY, Permission.XEM]);
    const dmTheoDoiCongBoHopQuy = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THEO_DOI_CONG_BO_HOP_QUY, Permission.XEM]);

    /** Quản lý năng lượng */
    const phongQLNL = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLNL, Permission.XEM]);
    const qlThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUY_DIEN, Permission.XEM]);
    const dmThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THUY_DIEN, Permission.XEM]);
    const qlTBA = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_TRAM_BA, Permission.XEM]);
    const dmTba110 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA110, Permission.XEM]);
    const dmTba220 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA220, Permission.XEM]);
    const dmTba500 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA500, Permission.XEM]);
    const qlCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CAP_DIEN, Permission.XEM]);
    const bcCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CAP_DIEN, Permission.XEM]);
    const tkCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CAP_DIEN, Permission.XEM]);
    const bcThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUY_DIEN, Permission.XEM]);
    const qlQuyTrinhVanHanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_QUY_TRINH_VAN_HANH, Permission.XEM]);
    const khSuDungNlTrongDiem = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KH_SU_DUNG_NL_TRONG_DIEM, Permission.XEM]);
    const dmKhSuDungNlTrongDiem = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KH_SU_DUNG_NL_TRONG_DIEM, Permission.XEM]);
    const qlNLTaiTaoVaNLKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_NL_TAI_TAO_VA_NANG_LUONG_KHAC, Permission.XEM]);
    const dmDuAnNLTaiTaoVaNLKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN_NL_TAI_TAO_VA_NANG_LUONG_KHAC, Permission.XEM]);
    const qlCapPhepHoatDongDienLuc = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CAP_PHEP_HOAT_DONG_DIEN_LUC, Permission.XEM]);
    const dmCapPhepHoatDongDienLuc = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CAP_PHEP_HOAT_DONG_DIEN_LUC, Permission.XEM]);// Quản lý đăng ký khuyến mãi
    const qlDangKyKhuyenMai = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DANG_KY_KHUYEN_MAI, Permission.XEM]);
    const bcDangKyKhuyenMai = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DANG_KY_KHUYEN_MAI, Permission.XEM]);

    /** Phòng Quản lý thị trường */
    const pQltt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLTT, Permission.XEM]);
    // Quản lý thị trường
    const qlThiTruong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THI_TRUONG, Permission.XEM]);
    const bcCtqlThiTruong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CTQL_THI_TRUONG, Permission.XEM]);

    /** Phòng Đầu Tư Xuất nhập khẩu */
    const pQldt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLDT, Permission.XEM]);
    // Quản lý xuất nhập khẩu
    const qlXuatNhapKhau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_XUAT_NHAP_KHAU, Permission.XEM]);
    const bcKimNgachXnk = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KIM_NGACH_XNK, Permission.XEM]);

    //Thanh tra
    const thanhTra = AuthenticationMenu(activedVaiTro, [Permission.THANH_TRA]);

    return (
      <Auxiliary>
        <Header className="qti-layout-header">
          <Row align="middle" justify="space-between" style={{ width: '100%' }} type="flex">
            {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE)
              ? (
                <Col sm={3} xs={4}>
                  <div className="gx-linebar gx-mr-3">
                    <i
                      className="gx-icon-btn icon icon-menu"
                      onClick={() => {
                        this.props.toggleCollapsedSideNav(!navCollapsed);
                      }}
                    />
                  </div>
                </Col>
              )
              : null}
            <Col lg={19} sm={15} xs={12}>
              <Menu
                className="qti-menu-head"
                mode="horizontal"
                onClick={this.onClickMenu}
                overflowedIndicator={<><Icon type="down" />Thêm</>}
                selectedKeys={[key || '']}
                theme="light"
              >
                {(thongKeAll
                  || phongQLTM
                  || qlXangDau || dmCoQuanChuQuan || dmDaiLyXangDau || bcCuaHangXangDau
                  || qlThuocLa || dmNhaBanBuon || bcBanBuonThuocLa || tkTinhHinhKinhDoanhThuocLa
                  || qlVSATTP || dmNganhNgheKD || dmDanhSachCSVSATTP || bcVSATTTP || tkTongHopCSVSATTP || tkCSVSATTP
                  || qlRuou || dmChungLoaiRuou || bcRuouTC || bcRuouCN
                  || qlCho || bcCho || tkPhatTrienCho
                  || qlTmdt || bcTmdt || tkTmdt
                  || qlDangKyKhuyenMai || bcDangKyKhuyenMai
                  || qlGas || bcGas || tkCuaHangGas
                  || qlDoanhNghiepDaCap || bcDoanhNghiepDaCap || tkDoanhNghiepDaCap
                  || qlHoiCho || bcHoiCho || tkHoiCho
                  || qlHopDongTheoMau || bcHopDongTheoMau || tkHopDongTheoMau
                  || qlDangKyDau || bcDangKyDau || tkDangKyDau
                  || dmThuongNhan || isThuongNhan
                  || qlThuocLa2020 || dmThuocLa2020 || dmQuanLyThuongNhanThuocLa || bcThuocLa2020 || bcThuongNhanBanLe || bcThuongNhanDuocCapPhep || bcTinhHinhKinhDoanh || bcTrongCayThuocLa || bcDauTuTrongCayThuocLa || bcThuongNhanBanBuon || bcPhanPhoiSanPhamThuocLa || bcBanHangTaiCacTinhThanhPho || bcBanHangTaiCacDiemBanLe
                  || qlRuou2020 || dmRuou2020 || dmQuanLyThuongNhanRuou || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu || bcSanXuatRuouKinhDoanh || bcSanXuatRuouBanChoDoanhNghiep || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa || bcBanLeRuou || bcBanRuouTieuDungTaiCho || bcRuouCoDoConDuoi55
                  || qlBieuMauKhac || bcTongMucBanLeHangHoa || bcTieuChiCshttmNongThon
                  || thanhTra
                ) && <Menu.Item key="/quan-ly-thuong-mai" className="qti-menuItem-top"><Link to="/quan-ly-thuong-mai">QUẢN LÝ THƯƠNG MẠI</Link></Menu.Item>}
                {(thongKeAll
                  || phongQLCN
                  || qlCumCNDA || dmCumCN || dmCoSoHaTang || dmDuAn || bcCCN || bcDuAn || tkKetCauHaTang
                  || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongUT || bcKhuyenCongDP || bcKqHoTro || bcUocTinhThucHien
                  || qlKCN || dmQLKCN || dmKcn || dmDuAnDauTu || bcKCN || tkKhuCongNghiep
                  || qlSanPhamCn || bcMotSoSpcnChuYeu || bcChiSoSanXuatCn || bcKqBinhChonSpcnTieuBieu
                ) && <Menu.Item key="/quan-ly-cong-nghiep" className="qti-menuItem-top"><Link to="/quan-ly-cong-nghiep">QUẢN LÝ CÔNG NGHIỆP</Link></Menu.Item>}
                {(thongKeAll
                  || phongKTATMT
                  || qlVLN || dmDoanhNghiep || dmLoaiHinhHD || bcVLN || tkCapPhepVLN
                  || qlHoaChat || bcCoSoHC || bcLoaiHC || bcSuCoHC || bcThanhTraHC || tkLoaiHC || tkSuCoHC || tkThanhTraHC
                  || thanhTra
                  || qlCongBoHopQuy || dmTheoDoiCongBoHopQuy
                ) && <Menu.Item key="/ky-thuat-an-toan-moi-truong" className="qti-menuItem-top"><Link to="/ky-thuat-an-toan-moi-truong">AN TOÀN MÔI TRƯỜNG</Link></Menu.Item>}
                {(phongQLNL
                  || qlThuyDien || dmThuyDien
                  || qlTBA || dmTba110 || dmTba220 || dmTba500
                  || qlCapDien || bcCapDien || tkCapDien || bcThuyDien
                  || qlQuyTrinhVanHanh
                  || qlNLTaiTaoVaNLKhac || dmDuAnNLTaiTaoVaNLKhac
                  || khSuDungNlTrongDiem || dmKhSuDungNlTrongDiem
                  || qlCapPhepHoatDongDienLuc || dmCapPhepHoatDongDienLuc
                  || thanhTra

                ) && <Menu.Item key="/quan-ly-nang-luong" className="qti-menuItem-top"><Link to="/quan-ly-nang-luong">QUẢN LÝ NĂNG LƯỢNG</Link></Menu.Item>}
                {(pQltt
                  || qlThiTruong || bcCtqlThiTruong
                ) && <Menu.Item key="/thi-truong" className="qti-menuItem-top"><Link to="/thi-truong">QUẢN LÝ THỊ TRƯỜNG</Link></Menu.Item>}
                {(pQldt
                  || qlXuatNhapKhau || bcKimNgachXnk
                ) && <Menu.Item key="/dau-tu-xuat-nhap-khau" className="qti-menuItem-top"><Link to="/dau-tu-xuat-nhap-khau">ĐẦU TƯ XUẤT NHẬP KHẨU</Link></Menu.Item>}
              </Menu>
            </Col>
            <Col lg={5} sm={6} xs={8}>
              <Row justify="end" type="flex">
                <UserInfo isDesktop={width >= TAB_SIZE} userInfo={userInfo} />
              </Row>
            </Col>
          </Row>
        </Header>
      </Auxiliary>
    );
  }
}

Topbar.propTypes = {
  switchLanguage: PropTypes.func.isRequired,
  toggleCollapsedSideNav: PropTypes.func.isRequired,
  navCollapsed: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired,
  navStyle: PropTypes.string.isRequired,
  userInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  activedVaiTro: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings }) => {
  const {
    locale, navStyle, navCollapsed, width
  } = settings;
  return {
    locale, navStyle, navCollapsed, width
  };
};

export default connect(mapStateToProps, { toggleCollapsedSideNav, switchLanguage })(Topbar);
